(function () {
  'use strict';

  const sections = document.querySelectorAll('.ol-boutique');
  if (!sections.length) return;

  sections.forEach(function (section) {
    const tabs = section.querySelectorAll('[data-ol-boutique-tab]');
    const groups = section.querySelectorAll('[data-ol-boutique-group]');
    if (!tabs.length || !groups.length) return;

    function activate(slug) {
      tabs.forEach(function (btn) {
        const on = btn.dataset.olBoutiqueTab === slug;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      groups.forEach(function (group) {
        const on = group.dataset.olBoutiqueGroup === slug;
        group.classList.toggle('is-active', on);
        if (on) {
          group.removeAttribute('hidden');
        } else {
          group.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.dataset.olBoutiqueTab);
      });
    });
  });
})();
